// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// styles
import * as styles from './HeaderPhones.scss';
import { formatPhoneNumber, removeIsraelCountryCode } from '../../../utils/formatPhoneNumber';

class HeaderPhones extends Component {
  state = {
    isShowPhone: false
  };

  shouldComponentUpdate(newProps, newState) {
    const isMobileIsChanged = (newProps.isMobile !== this.props.isMobile);
    const localeIsChanged = (newProps.locale && newProps.locale !== this.props.locale);
    const isShowPhoneChanged = newState.isShowPhone !== this.state.isShowPhone;

    return (localeIsChanged || isShowPhoneChanged || isMobileIsChanged);
  }


  onShowPhones = () => {
    this.setState({ isShowPhone: true });
  };

  maskPhone = (phone = '') => `${phone.toString().substr(0, 3)}-XXXXXXX`;

  render() {
    const { translate, phoneNumber, className, isIconFill, callToActionText } = this.props;
    const shouldHidePhone = (!this.state.isShowPhone);
    const formattedPhone = removeIsraelCountryCode(phoneNumber);
    return (
      <div className={cx(styles.phoneBlock, className)}>
        <span className={`icon ${isIconFill ? 'icon-phone-fill' : 'icon-phone'}`} />
        {callToActionText || translate('callNow')}:&nbsp;&nbsp;
        {shouldHidePhone
          ? <span className={styles.phoneMask}>{this.maskPhone(formattedPhone)}</span>
          : <a href={`tel:${phoneNumber}`} data-rel="external" >{formatPhoneNumber(formattedPhone)}</a>}
        {shouldHidePhone && <button onClick={this.onShowPhones}>{translate('showNumber')}</button>}
      </div>
    );
  }
}

HeaderPhones.propTypes = {
  translate: PropTypes.func,
  className: PropTypes.string,
  phoneNumber: PropTypes.string,
  callToActionText: PropTypes.string,
  isMobile: PropTypes.bool,
  locale: PropTypes.string,
  isIconFill: PropTypes.bool
};

export default HeaderPhones;
